import { render } from "./modal-flag.vue?vue&type=template&id=444d08f0"
import script from "./modal-flag.vue?vue&type=script&lang=js"
export * from "./modal-flag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__